import React, { memo } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import { AUTH_CONTROL_HEIGHT_CLASS } from "./constants/auth-controls";

interface ISocialButtonProps {
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
  testId?: string;
  isCentered?: boolean;
}

export const SocialButton = memo(
  ({
    onClick,
    icon,
    label,
    testId,
    isCentered = false,
  }: ISocialButtonProps): React.ReactElement => {
    return (
      <Button
        variant="outline"
        size="lg"
        className={cn(
          AUTH_CONTROL_HEIGHT_CLASS,
          "w-full bg-background hover:bg-accent/30 hover:border-primary hover:text-foreground",
          isCentered ? "justify-center" : "justify-start pl-5",
        )}
        onClick={onClick}
        type="button"
        data-testid={testId}
      >
        {icon}
        {label}
      </Button>
    );
  },
);
